import { Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-wizard-layout',
  templateUrl: './wizard-layout.component.html',
  styleUrls: ['./wizard-layout.component.scss'],
})
export class WizardLayoutComponent {
  @ViewChild(RouterOutlet) routerOutlet!: RouterOutlet;

  onCloseWizard(): void {
    // Delegate close event to the wizard shell component
    const wizardShell = this.routerOutlet?.component as any;
    if (wizardShell && typeof wizardShell.handleWizardClose === 'function') {
      wizardShell.handleWizardClose();
    } else {
      console.warn('[WizardLayout] No handleWizardClose method found on child component');
    }
  }
}

